import React, {useState} from 'react'
import { Grid, Avatar } from "@mui/material"

import Enviro from '../../assets/img/APP enviro.png';
import Nanoox from '../../assets/img/APP-nanoox-1 (003).png';
import NanooxBolt from '../../assets/img/APP-nanoox-Bolt.png';
import Pss from '../../assets/img/APP pss.png';
import Scapp from '../../assets/img/APP-scapp.png';

import LogoutIcon from '@mui/icons-material/Logout';
import RoomPreferencesIcon from '@mui/icons-material/RoomPreferences';

import {LogoutUsuario} from '../../utils/ApiLogin'
import { normalizeSuperuserCargo } from '../../features/ai-usage/aiUsageClient';

// Mapping service keys to their icons
const serviceIcons = {
  enviro: Enviro,
  nanoox: Nanoox,
  flux:NanooxBolt,
  pss: Pss,
  scapp: Scapp,
};

const generarColorAvatar = (username) => {
    const safeUsername = typeof username === 'string' ? username.trim() : '';

    if (!safeUsername) {
        return '#5F6B76';
    }

    // Generar un valor hash a partir del nombre de usuario
    let hash = 0;
    for (let i = 0; i < safeUsername.length; i++) {
        hash = safeUsername.charCodeAt(i) + ((hash << 5) - hash);
    }
    // Convertir el hash a un color hexadecimal
    const color = (hash & 0x00FFFFFF).toString(16).toUpperCase();
    // Añadir ceros a la izquierda si es necesario
    return "#" + "000000".substring(0, 6 - color.length) + color;
};

const PanelPrincipal = ({SWVersion, translate, servicioFiltrado, setServicioFiltrado, cargo, serviceList, servidor,serviciosCentro}) => {
  
  const [bgColor, setBgColor] = useState(true); // Color inicial del fondo
  
  const usuarioLogeado = (localStorage.getItem('username') || '').trim()
  
  const getInitial = (name) => {
    return name ? name.charAt(0).toUpperCase() : '';
  };

  const handleUsersItemClick = () => {
    window.location.href = '/config/create_center'; // Redireccionar a la ruta de Usuarios
  };

  const handleExit = async () => {
    // Llama a la función que borra las cookies en el servidor
    await LogoutUsuario(servidor);
    window.location.href = '/'; // 
  };

  const isServiceEnabled = (svc) => {
    const regiones = Object.values(serviciosCentro || {});
    for (const area of regiones) {
      for (const centro of Object.values(area || {})) {
        if (centro[svc]?.status_service) return true;
      }
    }
    return false;
  };



  const styleFont='1vw'
// console.log('cargo',cargo)

  return (
    
    <div className="extra-panel">
        <Grid container justifyContent='center' alignContent='center' alignItems='center' style={{ height:'7vh' }}>
            <Grid container justifyContent='center' alignContent='center' alignItems='center' item xs={12} 
            sx={{ height: '5vh', width:'12vw', marginBottom:'1.5vh', borderRadius:'1vh' }}>
                <Grid  item xs={2} alignContent='center' /*className="circle-container"*/>
                    <Avatar sx={{  bgcolor: generarColorAvatar(usuarioLogeado) , fontSize:'2vw', width:'2.5vw', height:'2.5vw', paddingTop:'-0.5vh'  }}>
                        {getInitial(usuarioLogeado)}
                    </Avatar>
                </Grid>
            </Grid>
        </Grid>
        <>
            {normalizeSuperuserCargo(cargo) && (
                <Grid container onClick={handleUsersItemClick} style={{backgroundColor:!bgColor ? '#252525': 'transparent',}}>
                        <Grid container justifyContent='center'  >
                                {/* boton para selecicionar regiones 3f3f3f */}
                                <Grid container justifyContent='center' item xs={12}
                                    sx={{
                                        height: '5vh',
                                        width:'10vw',
                                        borderRadius:'1vh',
                                        justifyContent: 'initial',
                                        px: 1,
                                        fontSize: "1.5vh", 
                                        '&:hover': {
                                          backgroundColor: '#3f3f3f', 
                                        },
                                    }}
                                >
                                    {/* icono de las Gestionar usuarios */}
                                    <Grid item xs={1} alignContent='center'>
                                        <RoomPreferencesIcon style={{fontSize:styleFont}} />
                                    </Grid>
                                    {/* nombre de las Gestionar usuarios */} 
                                    <Grid item xs={9}  alignContent='center' textAlign='initial' marginLeft='1vw'>
                                        <p sx={{ opacity:  1 , }} style={{fontSize: '0.7vw', }}> {translate('config')} </p>
                                    </Grid>
                                </Grid>
                        </Grid>
                </Grid>
            )}
            <Grid onClick={handleExit} container style={{  borderBottom: '0.1vh solid #3f3f3f',height: '6vh',backgroundColor:!bgColor ? '#252525': 'transparent',}}>
                    <Grid container justifyContent='center'  >
                            {/* boton cerrar sesion */}
                            <Grid container justifyContent='center' item xs={12}
                                sx={{
                                    height: '5vh',
                                    width:'10vw',
                                    borderRadius:'1vh',
                                    justifyContent: 'initial',
                                    px: 1,
                                    fontSize: "1.5vh", 
                                    '&:hover': {
                                        backgroundColor: '#3f3f3f', // puedes cambiar el color y grosor del borde a tu gusto
                                    },
                                }}
                            >
                                {/* icono de las regiones */}
                                <Grid item xs={1} alignContent='center'>
                                    <LogoutIcon style={{fontSize:styleFont}} />
                                </Grid>
                                {/* nombre de las regiones */} 
                                <Grid item xs={9}  alignContent='center' textAlign='initial' marginLeft='1vw'>
                                    <p sx={{ opacity: 1 , }} style={{fontSize: '0.7vw', }}>  {translate('cerrar_sesion')}     </p>
                                </Grid>
                            </Grid>
                    </Grid>
            </Grid>

            <div style={{ display:'flex', justifyContent:'center', alignContent:'center', alignItems:'center', flexDirection:'column'}}>
              <h2 className={!servicioFiltrado ? 'animate-glow' : ''} style={{color:'#c3c3c3', fontSize:'.9vw'}}>Selecciona un Servicio</h2>
              {/* <ul className="service-selector-list"> */}
                {serviceList.map(svc => {
                  
                  const enabled = isServiceEnabled(svc);
                  console.log('svc',svc)
                  return(
                    <div key={svc} style={{marginBottom:'1vh'}}>
                      <img
                        src={serviceIcons[svc]}
                        alt={svc}
                        className={`service-img  ${servicioFiltrado === svc ? ' selected' : ''}`}
                        style={{ 
                          transform: servicioFiltrado === svc ? 'scale(1.4)' : 'scale(1)', 
                          marginTop: servicioFiltrado === svc ? '1vh' : '',  
                          marginBottom: servicioFiltrado === svc ? '1vh' : '',
                          opacity: enabled ? 1 : 0.35,     // 
                          filter: enabled ? 'none' : 'grayscale(100%)', // 
                          transition: '0.2s ease-in-out',              
                          borderRadius: svc === 'flux' ? '.4vw' : '0',        
                        }}
                        // onClick={() => setServicioFiltrado(svc)}
                        onClick={() => {
                          if (!enabled) return; // ❌ Si está inhabilitado, no hace nada
                          setServicioFiltrado(svc);
                        }}
                      />
                    </div>
                  )
                })}
              {/* </ul> */}
            </div>
        </>
         <Grid container justifyContent='center' alignContent='center' style={{height:'15vh', marginTop:'27vh', position: 'absolute', borderTop: '1px solid #2f2f2f',marginLeft:'-1vw', padding:'.5vw' }}>
            {/* Contenido del pie de página */}
            <Grid container justifyContent='flex-start' alignContent='center' style={{ height:'2.5vh'}}>
                <p style={{fontWeight:200, color:'#c3c3c3', fontSize: '0.7vw'}}> {translate('email_label')} informaciones@itgchile.com</p>
            </Grid>
            <Grid container justifyContent='flex-start' alignContent='center' style={{ height:'2.5vh'}}>
                <p style={{fontWeight:200, color:'#c3c3c3', fontSize: '0.7vw',}}> {translate('phone_label')} +56 (65) 22 52 881</p>
            </Grid>
            <Grid container justifyContent='flex-start' alignContent='center' style={{ height:'2.5vh'}}>
                <p style={{fontWeight:200, color:'#c3c3c3', fontSize: '0.7vw',}}> {translate('phone_label')} +56 (65) 22 50 080</p>
            </Grid>
            <Grid container justifyContent='flex-start' alignContent='center' style={{ height:'2.5vh'}}>
                <p style={{fontWeight:200, color:'#c3c3c3', fontSize: '0.7vw',}}>ITG Chile</p>
            </Grid>
            <Grid container justifyContent='center' alignContent='center' style={{ height:'2.5vh'}}>
                <p style={{fontWeight:200, fontSize: '0.7vw', color:'rgba(255,255,255,0.5)'}}>{SWVersion}</p>
            </Grid>
        </Grid>
    </div>

  )
}

export default PanelPrincipal
